// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logoSizeSelector_UKuJg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: auto;
  box-sizing: border-box;
}

.label_jaVLo {
  font-size: 1rem;
  color: var(--black-color);
  font-weight: 500;
  margin: 0;
  flex-shrink: 0;
}

.sizeOptions_T9cT9 {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.sizeButton_Um6oX {
  background: transparent;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #222222;
  font-weight: 600;
  border-radius: 4px;
  transition: all 0.2s ease;
  min-width: 40px;
  text-align: center;
  box-sizing: border-box;
}

.sizeButton_Um6oX:hover {
  color: #000000;
  background-color: #f5f5f5;
}

.sizeButton_Um6oX.selected_pRUsU {
  color: #000000;
  background-color: #f0f0f0;
  font-weight: 700;
}



@media (max-width: 1024px) {
  .logoSizeSelector_UKuJg {
    justify-content: space-between;
    gap: 12px;
  }

  .label_jaVLo {
    font-size: 0.95rem;
    flex-shrink: 0;
  }

  .sizeOptions_T9cT9 {
    gap: 6px;
    flex-wrap: wrap;
  }

  .sizeButton_Um6oX {
    padding: 7px 10px;
    font-size: 0.85rem;
    min-width: 38px;
  }
}


@media (max-width: 768px) {
  .logoSizeSelector_UKuJg {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .label_jaVLo {
    font-size: 0.9rem;
  }

  .sizeOptions_T9cT9 {
    gap: 6px;
    width: 100%;
    justify-content: space-between;
  }

  .sizeButton_Um6oX {
    padding: 6px 10px;
    font-size: 0.85rem;
    min-width: 35px;
    flex: 1 1;
  }
}


@media (max-width: 480px) {
  .logoSizeSelector_UKuJg {
    gap: 10px;
  }

  .label_jaVLo {
    font-size: 0.85rem;
  }

  .sizeOptions_T9cT9 {
    gap: 4px;
  }

  .sizeButton_Um6oX {
    padding: 5px 8px;
    font-size: 0.8rem;
    min-width: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/LogoSizeSelector/LogoSizeSelector.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;;;AAIA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;AACF;;;AAGA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,SAAO;EACT;AACF;;;AAGA;EACE;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".logoSizeSelector {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  min-height: auto;\n  box-sizing: border-box;\n}\n\n.label {\n  font-size: 1rem;\n  color: var(--black-color);\n  font-weight: 500;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.sizeOptions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.sizeButton {\n  background: transparent;\n  border: none;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #222222;\n  font-weight: 600;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  min-width: 40px;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.sizeButton:hover {\n  color: #000000;\n  background-color: #f5f5f5;\n}\n\n.sizeButton.selected {\n  color: #000000;\n  background-color: #f0f0f0;\n  font-weight: 700;\n}\n\n\n\n@media (max-width: 1024px) {\n  .logoSizeSelector {\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  .label {\n    font-size: 0.95rem;\n    flex-shrink: 0;\n  }\n\n  .sizeOptions {\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n\n  .sizeButton {\n    padding: 7px 10px;\n    font-size: 0.85rem;\n    min-width: 38px;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .logoSizeSelector {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .label {\n    font-size: 0.9rem;\n  }\n\n  .sizeOptions {\n    gap: 6px;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .sizeButton {\n    padding: 6px 10px;\n    font-size: 0.85rem;\n    min-width: 35px;\n    flex: 1;\n  }\n}\n\n\n@media (max-width: 480px) {\n  .logoSizeSelector {\n    gap: 10px;\n  }\n\n  .label {\n    font-size: 0.85rem;\n  }\n\n  .sizeOptions {\n    gap: 4px;\n  }\n\n  .sizeButton {\n    padding: 5px 8px;\n    font-size: 0.8rem;\n    min-width: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoSizeSelector": `logoSizeSelector_UKuJg`,
	"label": `label_jaVLo`,
	"sizeOptions": `sizeOptions_T9cT9`,
	"sizeButton": `sizeButton_Um6oX`,
	"selected": `selected_pRUsU`
};
export default ___CSS_LOADER_EXPORT___;
